<template>
  <condition-debug-panel
      :conditions="conditions"
      :type="type"
      :item-id="itemId"
      condition-type="visibility"
  />
  <condition-debug-panel
      :conditions="conditions"
      :type="type"
      :item-id="itemId"
      condition-type="validity"
  />
  <condition-debug-panel
      :conditions="conditions"
      :type="type"
      :item-id="itemId"
      condition-type="mandatory"
  />
</template>

<script setup>
import ConditionDebugPanel from "./ConditionDebugPanel.vue";

const props = defineProps({
  conditions: {
    required: true
  },
  type: {
    type: String,
    required: false,
    default: 'Question'
  },
  itemId: {
    type: [Number, String],
    required: false
  }
});
</script>